import React from 'react';
import '../about.css';
import aboutImg from "../images/own.png";

const About = () => {
  return (
    <section id="about" className="about-section">
      <h2 className="section-title">A LITTLE BIT ABOUT ME</h2>
      <div className="about-content">
        <div className="about-text">
          <p>
            Hello! I'm <strong>Mohammed Shoaib</strong>, a dedicated Front-End Developer with a passion
            for creating intuitive and responsive web interfaces. I bring designs to life using HTML,
            CSS, JavaScript, and React.
          </p>
          <p>
            My journey in web development began with curiosity and a desire to make the web more
            engaging. Over time, I have honed my skills in both development and creative fields like
            video and image editing.
          </p>
          <p>
            I aim to build seamless digital experiences that look great and perform flawlessly across
            devices. Let's connect and bring ideas to life on the web!
          </p>
          <div className="button-container">
            <a
              href="https://drive.google.com/file/d/1G4gxQT7tGXabRIdWJuWfWQovFvMZuGOV/view?usp=drivesdk"
              target="_blank"
              rel="noopener noreferrer"
              className="resume-button"
            >
              View Resume
            </a>
          </div>
        </div>
        <div className="about-photo">
          <img src={aboutImg} alt="Shoaib" loading="lazy" />
        </div>
      </div>
      <br /><br /><hr />
    </section>
  );
};

export default About;